import useSWRImmutable from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetRuleFields = ():{ fields: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelValuePair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWRImmutable<ILabelValuePair[], AxiosError>('/policy/getConditionFieldOptions',
    (url) => fetcher(url));

  return {
    fields: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetRuleFields;
